export const PREVIEWS_AMOUNT = 5
